export default "__VITE_ASSET__8286070e__"